import { Button, Card, Group, Image, MantineTheme, Stack, Text, Title } from "@mantine/core";
import { getGoogleMapsStreetViewImage, latLng, RecordGroupManager, useEntityUI, ValuesRecord } from "@mcurros2/microm";
import { ReactNode } from "react";
import { CoberturaTiendasViewColumnsOverrides } from "./CoberturaTiendasViewColumnsOverrides";


export function CoberturaTiendasViewInfoWindowRenderer(
    record: ValuesRecord,
    position: latLng,
    groupManager: RecordGroupManager,
    infoWindow: google.maps.InfoWindow,
    UIAPI: ReturnType<typeof useEntityUI>,
    theme: MantineTheme
) {
    const columnsRender = CoberturaTiendasViewColumnsOverrides(theme);

    const group = groupManager.getGroupByLocation(position);
    if (group) {
        return (
            <Card withBorder>
                <Stack spacing="xs" mb="xs">
                    <Image width={350} height={120} src={getGoogleMapsStreetViewImage(position, 350, 200, 150)} mx="auto" />
                    {group.records.map(
                        ({ recordValue: rec }, index) => <Group key={`grp_${rec[0]}`}>
                            <Title order={5}>{`ID: ${rec[0]} ${rec[2]}${rec[2] && rec[1] ? ' - ' : ''}${rec[1]}`}</Title>
                            <Button size="xs" onClick={async () => {
                                await UIAPI.handleEditClick({ 'c_tienda_id': rec[0] });
                            }} >Editar</Button>
                        </Group>
                    )
                    }
                    <Group>
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
    else {
        const cobertura_compartida = columnsRender[5]!.render!(record[5]);
        const cobertura_exclusiva = columnsRender[6]!.render!(record[6]);


        return (
            <Card withBorder padding="xs">
                <Stack spacing="0.1rem">
                    <Image width={350} height={120} src={getGoogleMapsStreetViewImage(position, 350, 200, 150)} mx="auto" />
                    <Title mx="auto" mb="xs" order={4}>{`${record[2]}${record[2] && record[1] ? ' - ' : ''}${record[1]}`}</Title>
                    <Group spacing="xs">
                        <Text weight={500} size="sm">Supervisión: </Text>
                        {columnsRender[4]!.render!(record[4])}
                    </Group>
                    {record[5] !== '' &&
                        <Group spacing="0rem">
                            <Text mr="xs" weight={500} size="sm">Cobertura compartida: </Text>
                            {cobertura_compartida}
                            {(record[5] === 'OK') ? <Text weight={400} size="xs">({record[7] as ReactNode} horas)</Text> : ''}
                            {(record[5] !== 'OK') ? <Text ml="xs" weight={400} size="xs">(configuradas: {record[7] as ReactNode} horas)</Text> : ''}
                        </Group>
                    }
                    {record[6] !== '' &&
                        <Group spacing="0rem">
                            <Text mr="xs" weight={500} size="sm">Cobertura exclusiva: </Text>
                            {cobertura_exclusiva}
                            {(record[6] === 'OK') ? <Text weight={400} size="xs">({record[8] as ReactNode} horas)</Text> : ''}
                            {(record[6] !== 'OK') ? <Text ml="xs" weight={400} size="xs">(configuradas: {record[8] as ReactNode} horas)</Text> : ''}
                        </Group>
                    }
                    {record[11] !== null &&
                        <Group spacing="0.5rem">
                            <Text weight={500} size="sm">Visitas: </Text>
                            {record[11] as ReactNode}
                        </Group>

                    }
                    <Group spacing="0.5rem">
                        <Text weight={500} size="sm">Cantidad de clientes: </Text>
                        {columnsRender[12]!.render!(record[12])}
                    </Group>
                    <Group spacing="0.5rem">
                        <Text weight={500} size="sm">Cantidad de productos: </Text>
                        {columnsRender[13]!.render!(record[13])}
                    </Group>
                    <Group position="right">
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                        <Button size="xs" onClick={async () => {
                            await UIAPI.handleEditClick({ 'c_tienda_id': record[0] });
                        }} >Editar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
}